import { computed, getCurrentInstance } from 'vue';

const useDeviceHook = () => {
  const { proxy } = getCurrentInstance();

  const isAndroidMobileDevice = computed(() => /android/i.test(navigator.userAgent || navigator.vendor || window.opera));
  const isIOSMobileDevice = computed(() => /iPad|iPhone|iPod/.test(navigator.userAgent || navigator.vendor || window.opera) && !window.MSStream);

  const openSmsExternalApp = (shortcodeKey, messageKey) => {
    if (!isAndroidMobileDevice.value && !isIOSMobileDevice.value) return;

    const shortcode = proxy.$_translateByOperator(shortcodeKey);
    const message = proxy.$_translateByOperator(messageKey);

    let smsLink = '';

    if (isAndroidMobileDevice.value) {
      smsLink = `sms:${ shortcode }?body=${ message }`;
    } else if (isIOSMobileDevice.value) {
      smsLink = `sms:${ shortcode }&body=${ message }`;
    }

    window.location.href = smsLink;
  };

  return {
    isAndroidMobileDevice: isAndroidMobileDevice.value,
    isIOSMobileDevice: isIOSMobileDevice.value,
    isMobileDevice: isAndroidMobileDevice.value || isIOSMobileDevice.value,
    openSmsExternalApp,
  };
};

export default useDeviceHook;
